import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export enum MaxWidth {
  SM = 'width-minimum',
  MD = 'width-medium',
  LG = 'width-maximum'
}

@Injectable()
export class ResponsiveService {
  private _width:MaxWidth;
  private setWidthSubject:Subject<MaxWidth> = new Subject<MaxWidth>();
  
  public onSetWidth:Observable<MaxWidth> = this.setWidthSubject.asObservable();

  /**
   * @ngdoc method
   * @name ga2.shared.services:responsiveService#set%20width
   * @methodOf ga2.shared.services:responsiveService
   * @description
   * Sets symbolic width of the main container (one of WIDTH_MINIMUM, WIDTH_MEDIUM, WIDTH_MAXIMUM). Is applied to {@link ga2.common.directive:maxWidthx} directive.
   */
  public set width(width:MaxWidth) {
    this._width = width;
    this.setWidthSubject.next(this.width);
  }

  /**
   * @ngdoc method
   * @name ga2.shared.services:responsiveService#get%20width
   * @methodOf ga2.shared.services:responsiveService
   * @description
   * Gets the current symbolic width of the main container (one of WIDTH_MINIMUM, WIDTH_MEDIUM, WIDTH_MAXIMUM).
   */
  public get width():MaxWidth {
    return this._width;
  }

  /**
   * @ngdoc method
   * @name ga2.shared.services:responsiveService#getFixedHeaderHeight
   * @methodOf ga2.shared.services:responsiveService
   * @description Returns the total height of the header (only the fixed parts)
   * @returns {boolean} the number of pixels
   */
  public getFixedHeaderHeight = ():number => {
    let height:number = 0;
    const navbarElms:JQuery<HTMLElement> = $('.navbar');
    for (let i = 0; i < navbarElms.length; i++) {
      const navBarElm = navbarElms.eq(i);
      if (navBarElm.css('position') === 'fixed') {
        height = Math.max(height, navBarElm.position().top + navBarElm.outerHeight());
      }
    }
    return height;
  };
}